module.exports = __webpack_public_path__ + "img/first-day-7.456e8410.png";